export class TopicModel {
  title: string;
  route: string;
  imageUrl: string;

  constructor(title: string, route: string, imageUrl: string) {
    this.title = title;
    this.route = route;
    this.imageUrl = imageUrl;
  }

  updateRoute(newRoute: string): void {
    this.route = newRoute;
  }

  updateImage(newImageUrl: string): void {
    this.imageUrl = newImageUrl;
  }
}
